import { Skeleton } from "@chakra-ui/react";
import { InformationContainer, Pill, PillSlider } from "./WelcomeBanner.styled";

const WelcomeBanner = ({ memberDetails, isLoading }) => {
  if (isLoading) {
    return (
      <>
        <PillSlider>
          <Skeleton>
            <Pill style={{ backgroundColor: "#c1f0b2" }}>
              ACTIVE MEMBERSHIP
            </Pill>
          </Skeleton>
        </PillSlider>
        <Skeleton>
          <InformationContainer
            style={{ height: "300px" }}
          ></InformationContainer>
        </Skeleton>
      </>
    );
  }

  return (
    <PillSlider>
      {memberDetails.membershipStatus === "ACTIVE" && (
        <Pill style={{ backgroundColor: "#c1f0b2" }}>ACTIVE MEMBERSHIP</Pill>
      )}
      {memberDetails.membershipStatus === "EXPIRING" && (
        <Pill style={{ backgroundColor: "#f5da64" }}>EXPIRING MEMBERSHIP</Pill>
      )}
      {(memberDetails.membershipStatus === "EXPIRED" ||
        memberDetails.membershipStatus === "NEW") && (
        <Pill style={{ backgroundColor: "#f0c1b2" }}>EXPIRED MEMBERSHIP</Pill>
      )}
      {(memberDetails.isCoach || memberDetails.isActivator) &&
        memberDetails.coachStatus === "ACTIVE" && (
          <Pill style={{ backgroundColor: "#c1f0b2" }}>ACTIVE COACH</Pill>
        )}
      {(memberDetails.isCoach || memberDetails.isActivator) &&
        memberDetails.coachStatus === "EXPIRING" && (
          <Pill style={{ backgroundColor: "#f5da64" }}>EXPIRING COACH</Pill>
        )}
      {(memberDetails.isCoach || memberDetails.isActivator) &&
        memberDetails.coachStatus === "EXPIRED" && (
          <Pill style={{ backgroundColor: "#f0c1b2" }}>EXPIRED COACH</Pill>
        )}
      {(memberDetails.isCoach || memberDetails.isActivator) &&
        memberDetails.coachStatus === "NEW" && (
          <Pill style={{ backgroundColor: "#f0c1b2" }}>NEW COACH</Pill>
        )}
    </PillSlider>
  );
};

export default WelcomeBanner;
